import createHistory from 'history/createBrowserHistory'
import thunk from 'redux-thunk'
import { createStore, applyMiddleware, compose } from 'redux'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import { rootReducer } from './modules'
import { firebaseMain } from './firebase_client'
import { persistReducer, persistStore } from 'redux-persist';

import { reactReduxFirebase, getFirebase } from 'react-redux-firebase'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import createDebounce from 'redux-debounced';


const persistConfig = {
  storage: storage,
  key: 'root',
  blacklist: ['router', 'uiReducer', 'alert']
}

export const rrfConfig = {
  attachAuthIsReady: true,
  userProfile: 'users',
  enableLogging: !!(process.env.NODE_ENV === 'development'),
  fileMetadataFactory: (uploadRes: { metadata: { name: any; fullPath: any; contentType: any } }) => {
    // upload response from Firebase's storage upload
    const {
      metadata: { name, fullPath, contentType }
    } = uploadRes
    // default factory includes name, fullPath, downloadURL
    return {
      name,
      fullPath,
      contentType,
      import_status: 'not_started'
    }
  }
}

export const history = createHistory()

const initialState = {}

const uniqueIdSelector = (state: { firebase: { auth: { uid: any } } }) => {
  if (!state.firebase.auth) {
    return null
  }
  return state.firebase.auth.uid
}

const personSelector = (state: { firebase: { profile: { first_name: any; last_name: any; email: any } } }) => {
  if (!state.firebase.profile) {
    return null
  }
  return {
    clientId: 'dockpad-web-app',
    clientName: 'DockPad Web App',
    $first_name: state.firebase.profile.first_name,
    $last_name: state.firebase.profile.last_name,
    $email: state.firebase.profile.email
  }
}


const middleware = [
  createDebounce(),
  routerMiddleware(history),
  thunk.withExtraArgument(getFirebase),
]

const composeEnhancers = process.env.NODE_ENV === 'development' ? (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose) : compose

const configureStore = () => {

  const store = createStore(
    persistReducer(persistConfig, rootReducer(history)),
    initialState,
    composeEnhancers(
      applyMiddleware(...middleware)
    )
  )

  const persistor = persistStore(store)

  return {
    store, persistor
  }
}

export const { store, persistor } = configureStore();


if (typeof module.hot !== 'undefined') {
  module.hot.accept('./modules', () => {

      const nextRootReducer = require('./modules').rootReducer
      
      store.replaceReducer(
          persistReducer(persistConfig, nextRootReducer)
      )
  });
}
export default store;



// WEBPACK FOOTER //
// ./src/app-store.ts